//SYSTEM_UUID 
export const SYSTEM_UUID = process.env.REACT_APP_ANDESCLOUD_UUID;
export const PORTAL_UUID = process.env.REACT_APP_PORTAL_UUID;
export const REACT_APP_ITEM_PERPAGE = 15;
export const REACT_APP_TYPE_ITEMS = [2, 3, 4, 9, 10, 12];
export const INVOICE_UNIT_PRICE_MAX = 17;
export const QUOTATION_UNIT_PRICE_MAX = 10;
export const QUOTATION_ITEM_COUNT_MAX = 13;
export const BUKKEN_TAB_COUNT_CHECKED_MAX = 10;
